import { DateTime } from 'luxon';
import React from 'react';
interface CustomizedAxisTickProps {
  x: number;
  y: number;
  payload: { value: any };
}

const CustomizedYAxisTick = (props: CustomizedAxisTickProps) => {
  const { x, y, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill="#666"
        transform="rotate(-35)"
        style={{ fontFamily: 'Montserrat', fontSize: 8, fontWeight: 400 }}
      >
        {DateTime.fromISO(payload.value).toFormat('dd LLL')}
      </text>
    </g>
  );
};
export default CustomizedYAxisTick;
